import { useLingui } from '@lingui/react/macro';

import { I18nWording } from '@/services/i18n';

import { LocaleInputs } from './LocaleInputs';

export const NameInputs = ({
  name,
  setName,
  showErrors,
}: {
  name: I18nWording;
  setName: (name: I18nWording) => void;
  showErrors: boolean;
}) => {
  const { t } = useLingui();

  return (
    <LocaleInputs
      label={t({
        id: 'settings.actions.actions.drawer.name',
        message: `Name`,
      })}
      placeholder={t({
        id: 'settings.actions.actions.drawer.name',
        message: `Name`,
      })}
      value={name}
      setValue={setName}
      showErrors={showErrors}
    />
  );
};
